export const HR_PORTAL_DOMAIN = 'https://hr.zepcruit.ai/auth/login';